import { useTranslation } from 'react-i18next';

export default function ConnaitreQuartier() {
  const { t } = useTranslation('charny');

  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-[#1B2A4E] mb-5 md:mb-6 leading-tight">
              {t('quartier_h2')}
            </h2>
            <p className="text-sm md:text-base text-[#4A5568] leading-relaxed mb-4">
              {t('quartier_p1')}
            </p>
            <p className="text-sm md:text-base text-[#4A5568] leading-relaxed">
              {t('quartier_p2')}
            </p>
          </div>

          <div className="rounded-lg overflow-hidden h-[320px] md:h-[400px]">
            <img
              src="https://readdy.ai/api/search-image?query=Historic%20railway%20station%20area%20in%20a%20small%20Quebec%20town%20with%20old%20worker%20houses%20and%20newer%20residential%20buildings%20nearby%2C%20autumn%20setting%2C%20authentic%20neighborhood%20character%2C%20mix%20of%20century-old%20homes%20and%20modern%20developments%2C%20warm%20earthy%20tones%2C%20slate%20blue%20sky%20with%20copper%20autumn%20leaves&width=700&height=500&seq=charny-quartier-1&orientation=landscape"
              alt="Quartier Charny avec gare historique et maisons ouvrières à Lévis"
              className="w-full h-full object-cover object-top"
              loading="lazy"
              width="700"
              height="500"
            />
          </div>
        </div>
      </div>
    </section>
  );
}